import React, { useCallback, useEffect } from 'react';
import './HomeView.scss';
import { Content, EventList, Header } from '@turing/components';
import { Col, Row } from 'antd';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getMeetingSessionEvents } from 'store/features/event-slice';
import { getCorrectionEvents } from 'store/features/event-slice';
import { EventModal } from '@turing/modals';

const TIMEOUT = 300000; // 5 minutes in miliseconds

export const HomeView = () => {
  const dispatch = useAppDispatch();
  const showSchedule = useAppSelector(state => state.event.showSchedule);

  const getEventsData = useCallback(() => {
    dispatch(getMeetingSessionEvents());
    dispatch(getCorrectionEvents());
  }, [dispatch]);

  useEffect(() => {
    getEventsData();

    const eventCallsIntervalId = setInterval(() => {
      getEventsData();
    }, TIMEOUT);

    return () => {
      clearInterval(eventCallsIntervalId);
    };
  }, [getEventsData]);

  return (
    <div className="home-view">
      <EventModal />
      <Header />
      <Row className="main-container">
        <Col xs={24} sm={24} md={10} lg={10} xl={10} xxl={10} className={`events-wrapper ${showSchedule && 'show-on-top'}`}>
          <EventList />
        </Col>
        <Col xs={0} sm={0} md={14} lg={14} xl={14} xxl={14} className="content-wrapper">
          <Content />
        </Col>
      </Row>
    </div>
  );
};
